import React from "react";
import {
 Box,
 Heading,
 List,
 ListItem,
 Flex,
 Circle,
 Text,
} from "@chakra-ui/react";
const AdmissionProcessSection = ({ admissionProcess }) => {
 const steps = Array.isArray(admissionProcess)
  ? admissionProcess.filter((step) => step.trim() !== "")
  : admissionProcess
     ?.split(/[\n\r.]+/)
     .map((s) => s.trim())
     .filter((s) => s.length > 0);

 if (!steps || steps.length === 0) return null;

 return (
  <Box mb={8}>
   <Heading as="h2" size="md" mb={4}>
    Admission Process
   </Heading>

   <List spacing={4}>
    {steps.map((step, index) => (
     <ListItem key={index}>
      <Flex>
       <Circle
        size="32px"
        bg="red.500"
        color="white"
        mr={4}
        fontSize="sm"
        fontWeight="bold"
       >
        {index + 1}
       </Circle>
       <Box pt={1}>
        <Text>{step}</Text>
       </Box>
      </Flex>
     </ListItem>
    ))}
   </List>
  </Box>
 );
};

export default AdmissionProcessSection;
